import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import { EditableTableCell } from 'components/EditableTable';
import selectStyles from 'components/StyledSelect/react-select-styles.scss';
import { error as parseError } from '../../../utils';
import S from 'styles/table.scss';

const DropdownCell = (props) => {
  const { lineItem, attr, label, options, onChange, cellValue,
          display, isIdAttr, clearable, children } = props;
  const valueAttr = isIdAttr ? `${attr}_id` : attr;
  const selectValue = lineItem[valueAttr] || '';
  const value = cellValue || children || selectValue;
  const error = lineItem.errors && lineItem.errors[attr] && parseError(attr, lineItem.errors);
  const cellProps = { display, label, value, error };
  return (<EditableTableCell
    {...cellProps}
    onChange={onChange}
    className={S.largeColumn}
  >
    <ReactSelect
      autoSize={false}
      options={options}
      value={selectValue}
      simpleValue
      matchProp="label"
      className={selectStyles.prettyDropDown}
      clearable={clearable}
      backspaceRemoves={clearable}
      deleteRemoves={clearable}
    />
  </EditableTableCell>);
};

DropdownCell.defaultProps = {
  cellValue: '',
  display: true,
  isIdAttr: false,
  clearable: false,
};

DropdownCell.propTypes = {
  lineItem: PropTypes.object.isRequired,
  display: PropTypes.bool,
  attr: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cellValue: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  isIdAttr: PropTypes.bool,
  clearable: PropTypes.bool,
  children: PropTypes.node,
};

export default DropdownCell;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/dropDownCell.jsx